<template>
  <div>
    <header>
      <p>二级页面</p>
    </header>
    <div class="body">
      <div class="head">
        <div class="tabs">
          <div class="tab" @click="tabFlag = 0" :class="tabFlag == 0 ? 'active' : ''">
            <p>应用</p>
            <a-badge class="badge" count="25" />
          </div>
          
          <div class="tab" @click="tabFlag = 1" :class="tabFlag == 1 ? 'active' : ''">
            <p>项目</p>
            <a-badge class="badge" count="25" />
          </div>
          <div class="tab" @click="tabFlag = 2" :class="tabFlag == 2 ? 'active' : ''">
            <p>文章</p>
            <a-badge class="badge" count="25" />
          </div>
        </div>

        <div class="operation">
          <button class="btn">查看日志</button>
          <a-button style="margin-left: 8px">
            导出数据
            <a-icon type="down" />
          </a-button>
          <button class="btnC">创建应用</button>
          <div class="icon">
            <a-icon type="reload" />
            <a-icon type="column-height" />
            <a-icon type="fullscreen" />
          </div>
        </div>
      </div>

      <div class="content">
        <div style="width:50%;margin:50px auto;">
          <a-alert
            message="Success Tips"
            description="Detailed description and advices about successful copywriting."
            type="success"
            closable
            show-icon
          />
          <div style="margin-bottom:10px"></div>
          <a-alert
            message="Informational Notes"
            description="Additional description and informations about copywriting."
            type="info"
            closable
            show-icon
          />
          <div style="margin-bottom:10px"></div>
          <a-alert
            message="Warning"
            description="This is a warning notice about copywriting."
            type="warning"
            closable
            show-icon
          />
          <div style="margin-bottom:10px"></div>
          <a-alert
            message="Error"
            description="This is an error message about copywriting."
            type="error"
            closable
            show-icon
          />
        </div>
        <button class="btnC" @click="info(1)">正常提示框</button>
        <button class="btnC" @click="info(2)">错误提示框</button>
        <button class="btnC" @click="info(3)">正确提示框</button>
        <button class="btnC" @click="info(4)">提示提示框</button>
        <button class="btnC" @click="info(5)">加载提示框</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabFlag: 0
    }
  },
  methods: {
    info(k) {
      switch (k) {
        case 1:
          this.$message.info('正常提示框');
          break;
        case 2:
          this.$message.error('错误提示框');
          break;
        case 3:
          this.$message.success('正确提示框');
          break;
        case 4:
          this.$message.warning('提示提示框');
          break;
        case 5:
          this.$message.loading('加载提示框');
          break;
        default:
          break;
      }

    },
  }
}
</script>

<style lang="scss" scoped>
header {
  height: 40px;
  width: 100%;
  p {
    font-size: $sixteen-PX;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
}
.body {
  width: 100%;
  min-height: 750px;
  background-color: #fff;
  padding: 0 $twenty-four-PX $sixteen-PX $twenty-four-PX;
  box-sizing: border-box;
  .head {
    height: 62px;
    width: 100%;
    @include flex(space-between);
    .tabs {
      @include flex(flex-start);

      .tab {
        @include flex(flex-start);
        cursor: pointer;
        position: relative;
        margin-right: 32px;
        /deep/ .ant-scroll-number {
          width: 32px;
          height: 20px;
          background: rgba(140, 140, 140, 0.1);
          border-radius: 12px;
          .ant-scroll-number-only {
            color: #000000;
          }
        }
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 3px;
          position: absolute;
          right: 0;
          bottom: -16px;
          background: $choose-color;
          transform: scale3d(0, 1, 1);
          transition: all 0.3s ease-in-out;
        }
        &:hover {
          &::after {
            transform: scale3d(1, 1, 1);
          }
        }
        p {
          margin-right: 8px;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      .active {
        /deep/ .ant-scroll-number {
          width: 32px;
          height: 20px;
          background: $four-level-bj-color;
          border-radius: 12px;
          .ant-scroll-number-only {
            color: $choose-color;
          }
        }
        &::after {
          transform: scale3d(1, 1, 1);
        }
        p {
          color: $choose-color;
          font-weight: 550;
        }
      }
    }

    .operation {
      @include flex(flex-start);
      .btn {
        padding: 0 16px;
        height: 32px;
        background: #fff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          background-color: #fafafa;
        }
      }
      .ant-btn {
        color: #000000;
        border: 1px solid rgba(0, 0, 0, 0.15);
        i {
          color: rgba(0, 0, 0, 0.25);
        }
        &:hover {
          background-color: #fafafa;
          color: #000000;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }

      .btnC {
        padding: 0 16px;
        height: 32px;
        background: $choose-color;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        border-radius: 2px;
        border: none;
        margin-left: 8px;
        transition: 0.3s;
        &:hover {
          opacity: 0.8;
        }
      }

      .icon {
        margin: 0 20px;
        @include flex(flex-s tart);
        i {
          cursor: pointer;
          margin-right: 28px;
          &:last-child {
            margin: 0;
          }

          &:hover {
            color: $choose-color;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    .btnC {
      padding: 0 16px;
      height: 32px;
      background: $choose-color;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      border-radius: 2px;
      border: none;
      margin-left: 8px;
      transition: 0.3s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>